exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".before-footer{color:#fff;padding:4rem 15px}.before-footer h2{font-size:1.5rem}.before-footer.modernized{padding:3.1rem 15px}.before-footer.modernized h2{margin-bottom:30px;font-size:1.875rem;font-weight:500;letter-spacing:-0.5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/BeforeFooter/BeforeFooter.scss
// module id = 7471
// module chunks = 11